import React, { useState, useEffect } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { motion,AnimatePresence } from "framer-motion";

function Tofuinent() {
const [index, setIndex] = useState(0);
 const [showSuccessModal, setShowSuccessModal] = useState(false);
   const [formType, setFormType] = useState(""); // stores which button opened the form
 const [showModal, setShowModal] = useState(false);
   const [animate, setAnimate] = useState(false);
   const [loading, setLoading] = useState(false);
 const slides = [
    { text: "Transform Intent Data into Real Sales Growth" },
    { text: "From Data to Deals — Power Your Growth with Intent Insights" },
    { text: "Capture Intent. Accelerate Conversions" },
  ];

const handleContactChange = (e) => {
  const { name, value } = e.target;
  setContactForm((prev) => ({ ...prev, [name]: value }));
};
const openModal = () => {
  setShowModal(true);
  setTimeout(() => setAnimate(true), 10); // trigger fade-in animation
};
  // 🔹 Close modal
  const closeModal = () => {
    setAnimate(false);
    setTimeout(() => setShowModal(false), 300);
  };
const [contactForm, setContactForm] = useState({
  fullname: "",
  company: "",
  website: "",
  email: "",
  phone: "",
  message: "",
});
const isBusinessEmail = (email) => {
  const freeDomains = [
    "gmail.com",
    "yahoo.com",
    "hotmail.com",
    "outlook.com",
    "aol.com",
    "icloud.com",
    "mail.com",
    "live.com"
  ];
  const domain = email.split("@")[1]?.toLowerCase();
  if (!domain) return false;
  return !freeDomains.includes(domain);
};

const handleContactSubmit = async (e) => {
  e.preventDefault();
 setLoading(true); // show loading message
  const { fullname, company, website, email, phone, message} = contactForm;
  // Basic validation
  if (!fullname || !email || !message || !company || !phone || !website) {
    alert("Please fill all required fields.");
      setLoading(false); // show loading message

    return;
  }
if (!isBusinessEmail(email)) {
    alert("Please enter a business email, not Gmail/Yahoo/etc.");
      setLoading(false); // show loading message

    return;
  }
 

  try {
    try {
    const emailCheckResponse = await fetch(
      `https://pinakinedgemedia.com/api/validateEmail?email=${email}`
    );
    const emailCheckData = await emailCheckResponse.json();

    if (!emailCheckData.exists) {
      setLoading(false);
      alert("❌ The entered email does not exist. Please use a valid business email.");
      return;
    }
  } catch (err) {
    setLoading(false);
    console.error("Email check failed:", err);
    alert("⚠️ Could not verify email existence. Try again later.");
    return;
  }
    const response = await fetch("https://pinakinedgemedia.com/api/sendContactMail", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
     body: JSON.stringify({
  ...contactForm,
  formType, // ✅ add formType manually here
}),

    });

    if (response.ok) {
       setShowSuccessModal(true);  // ✅ This triggers modal to open
       setLoading(false); // show loading message
      closeModal();
       setContactForm({
        fullname: "",
        company: "",
        website: "",
        email: "",
        phone: "",
        message: "",
      });
    } else {
      alert("Error sending message.");
    }
  } catch (err) {
    console.error(err);
    alert("Error sending message.");
  }
};
   useEffect(() => {
    const timer = setInterval(() => {
      setIndex((prev) => (prev + 1) % slides.length);
    }, 4500);
    return () => clearInterval(timer);
  }, [slides.length]);

  const currentSlide = slides[index] ?? { text: "" };

  return (
    
    <div>
      <Header />
       <main>
     
<AnimatePresence>
          {showSuccessModal && (
            <motion.div
              className="modal-overlay show"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              style={{
                position: "fixed",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                background: "rgba(0,0,0,0.5)",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                zIndex: 9999,
              }}
            >
              <motion.div
                className="modal show"
                initial={{ scale: 0.8, opacity: 0 }}
                animate={{ scale: 1, opacity: 1 }}
                exit={{ scale: 0.8, opacity: 0 }}
                transition={{ duration: 0.3 }}
                style={{
                  background: "#fff",
                  padding: "30px",
                  borderRadius: "10px",
                  width: "400px",
                  textAlign: "center",
                  boxShadow: "0 10px 25px rgba(0,0,0,0.2)",
                }}
              >
                <h2 style={{ fontSize: "20px", marginBottom: "10px" }}>
                  Message Sent!
                </h2>
                <p>Thank you for contacting us. We will get back to you shortly.</p>
                <button className="vc rg lk gh ml il hi gi _l"
                  onClick={() => setShowSuccessModal(false)}
                 
                >
                  Close
                </button>
              </motion.div>
            </motion.div>
          )}
        </AnimatePresence>
          {/* 🔹 Modal */}
                {showModal && (
                  <div
                    className={`modal-overlay ${animate ? "show" : ""}`}
                    onClick={(e) => {
                      if (e.target.classList.contains("modal-overlay")) {
                        closeModal();
                      }
                    }}
                    style={{
                      position: "fixed",
                      top: 0,
                      left: 0,
                      right: 0,
                      bottom: 0,
                      background: "rgba(0, 0, 0, 0.5)",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      zIndex: 1000,
                      opacity: animate ? 1 : 0,
                      transition: "opacity 0.3s ease",
                    }}
                  >
                    <motion.div
                      className="modal-box"
                      initial={{ scale: 0.8, opacity: 0 }}
                      animate={{ scale: 1, opacity: 1 }}
                      exit={{ scale: 0.8, opacity: 0 }}
                      transition={{ duration: 0.3 }}
                      style={{
                        position: "relative",
                        background: "#fff",
                        padding: "30px",
                        borderRadius: "10px",
                        textAlign: "center",
                        boxShadow: "0 10px 25px rgba(0,0,0,0.2)",
                      }}
                    >
                      {/* Close button */}
                      <button
                        onClick={closeModal}
                        style={{
                          position: "absolute",
                          top: "10px",
                          right: "15px",
                          background: "transparent",
                          border: "none",
                          fontSize: "22px",
                          cursor: "pointer",
                          color: "#333",
                        }}
                      >
                        ×
                      </button>
        
                      <h2 className="fk tj kk wm bb">
                       Contact Now
                      </h2>
                   <form onSubmit={(e) => handleContactSubmit(e)}>
  <div className="tc sf yo ap zf xi1">
    <div className="vd to/2">
      <input
        type="text"
        name="fullname"
        id="fullname"
        placeholder="Full name"
        value={contactForm.fullname}
        onChange={handleContactChange}
        className="vd ph sg zk xm _g ch pm hm dm dn em pl/50 xi1 mi"
      />
    </div>

    <div className="vd to/2">
      <input
        type="text"
        name="company"
        id="company"
         placeholder="Company name"
        value={contactForm.company}
        onChange={handleContactChange}
        className="vd ph sg zk xm _g ch pm hm dm dn em pl/50 xi1 mi"
      />
    </div>
  </div>

  <div className="tc sf yo ap zf xi1">
    <div className="vd to/2">
      <input
        type="text"
        name="website"
        id="website"
          placeholder="Website"
        value={contactForm.website}
        onChange={handleContactChange}
        className="vd ph sg zk xm _g ch pm hm dm dn em pl/50 xi1 mi"
      />
    </div>

    <div className="vd to/2">
      <input
        type="email"
        name="email"
         placeholder="Email address"
        id="email"
        value={contactForm.email}
        onChange={handleContactChange}
        className="vd ph sg zk xm _g ch pm hm dm dn em pl/50 xi1 mi"
      />
    </div>
  </div>

  <div className="tc sf yo ap zf xi1">
    <div className="vd to/2">
     <input
  type="text"
  name="phone"
  id="phone"
    placeholder="Phone number"
  value={contactForm.phone}
  onChange={(e) => {
    // Allow only digits
    const value = e.target.value.replace(/\D/g, "");
    setContactForm((prev) => ({ ...prev, phone: value }));
  }}
  maxLength={10} // optional: limit to 10 digits
  className="vd ph sg zk xm _g ch pm hm dm dn em pl/50 xi1 mi"
/>

    </div>
  </div>

  <div className="fb">
    <textarea
      placeholder="Message"
      rows="3"
      name="message"
      id="message"
      value={contactForm.message}
      onChange={handleContactChange}
      className="vd ph sg zk xm _g ch pm hm dm dn em pl/50 ci"
    ></textarea>
  </div>

  <div className="tc xf">
      <button
  type="submit"
  className="vc rg lk gh ml il hi gi _l"
  disabled={loading}
>
  {loading ? "Please wait..." : " Send Message"}
</button>

  </div>
</form>
                    </motion.div>
                  </div>
                )}
 <section className="hero-section herovv1">
      <video
        className="hero-video"
        src="/images/IntentVideo.mp4"
        autoPlay
        muted
        loop
        loading="lazy"
        playsInline
      />

      <div className="hero-overlay" />

      <div className="hero-content">
        <div className="hero-inner">
          <AnimatePresence mode="wait">
            <motion.h1
              key={index}
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -30 }}
              transition={{ duration: 0.8, ease: "easeOut" }}
              className="setslidtext"
            >
              {currentSlide.text}
            </motion.h1>
          </AnimatePresence>
        </div>
      </div>
    </section>

     <section className="i ji ii">
       {/* Bg Shapes */}
      <span className="rc h s r vd fd/5 fh rm"></span>
      <img src="/images/shape-08.svg" alt="Shape Bg" className="h q r" />

      {/* Section Title */}
      <div className="animate_top bb ze rj ki xn vq">
        <motion.section
                    initial={{ opacity: 0, y: 100 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: false, amount: 0.3 }} // 👈 play every time visible
                    transition={{
                      duration: 1.8,
                      ease: "easeOut",
                      type: "spring",
                      stiffness: 40,
                      damping: 20,
                    }}
                  ><h2 className="fk vj pr kk wm on/5 gq/2 bb _b">
         Intent Data Services
        </h2></motion.section>
       
      </div>
      <br/>
      <div className="container">
       <motion.section
                   initial={{ opacity: 0, y: 100 }}
                   whileInView={{ opacity: 1, y: 0 }}
                   viewport={{ once: false, amount: 0.3 }} // 👈 play every time visible
                   transition={{
                     duration: 1.8,
                     ease: "easeOut",
                     type: "spring",
                     stiffness: 40,
                     damping: 20,
                   }}
                 >
        <div className="left">
          <img src="/images/intent12.png" alt="Left Side" />
        </div>
</motion.section>
        {/* Right Side - Content */}
        <div className="right">
           <motion.section
                       initial={{ opacity: 0, y: 100 }}
                       whileInView={{ opacity: 1, y: 0 }}
                       viewport={{ once: false, amount: 0.3 }} // 👈 play every time visible
                       transition={{
                         duration: 1.8,
                         ease: "easeOut",
                         type: "spring",
                         stiffness: 40,
                         damping: 20,
                       }}
                     >
         <h3 className="fk tj kk wm bb _b mk">Early Signals. Smarter Outreach. Bigger Pipeline.</h3>
          <p className="uo">
           In B2B demand generation, timing is everything. By the time a buyer fills out a form or downloads a whitepaper, they’re likely already halfway through their decision-making process—and evaluating competitors. That’s why leading marketing and sales teams are shifting left, using intent data to detect early buying signals and engage prospects before anyone else, our intent data services are built to empower B2B organizations to identify, prioritize, and convert in-market buyers with unmatched speed and accuracy.
         </p>
           <div className="tc tf yo zf mb">
            <button
  type="button"
  className="ek jk lk gh gi hi rg ml il vc _d _l"
  onClick={() => {
    setFormType("Intent Data Services Page");
    openModal(true); // or scroll to form if no modal
  }}
>
   Lets chat to discover  
</button>
          </div>
         </motion.section>
        </div>
      </div>

    </section>
    
  
    <section className="i">
       {/* Bg Shapes */}
      <span className="rc h s r vd fd/5 fh rm"></span>
      <img src="/images/shape-08.svg" alt="Shape Bg" className="h q r" />

      {/* Section Title */}
      <div className="animate_top bb ze rj ki xn vq">
         <motion.section
                       initial={{ opacity: 0, y: 100 }}
                       whileInView={{ opacity: 1, y: 0 }}
                       viewport={{ once: false, amount: 0.3 }} // 👈 play every time visible
                       transition={{
                         duration: 1.8,
                         ease: "easeOut",
                         type: "spring",
                         stiffness: 40,
                         damping: 20,
                       }}
                     ><h2 className="fk vj pr kk wm on/5 gq/2 bb _b">
         Contact Discovery 
        </h2></motion.section>
       
      </div>
      <br/>
      <div className="container">
        <div className="left se2">
           <motion.section
                       initial={{ opacity: 0, y: 100 }}
                       whileInView={{ opacity: 1, y: 0 }}
                       viewport={{ once: false, amount: 0.3 }} // 👈 play every time visible
                       transition={{
                         duration: 1.8,
                         ease: "easeOut",
                         type: "spring",
                         stiffness: 40,
                         damping: 20,
                       }}
                     >
           <h3 className="fk tj kk wm bb _b mk">Trusted, High-Accuracy Data</h3>
             <p className="uo jutfy">
         Backed by a team with years of specialized experience, we provide accurate, up-to-date B2B contact data to address the prospecting challenges your sales teams face. Our focus is on delivering verified contacts that align with your ideal customer profile—ensuring you connect with the right decision-makers at the right companies, exactly when it matters. Using advanced search tools, we tailor contact discovery and verification based on your target criteria, including geography, job title, industry, revenue, and company size.
         </p>
           <div className="tc tf yo zf mb">
             
          </div>
         </motion.section>
        </div>
        <div className="right se1">
          <motion.section
                       initial={{ opacity: 0, y: 100 }}
                       whileInView={{ opacity: 1, y: 0 }}
                       viewport={{ once: false, amount: 0.3 }} // 👈 play every time visible
                       transition={{
                         duration: 1.8,
                         ease: "easeOut",
                         type: "spring",
                         stiffness: 40,
                         damping: 20,
                       }}
                     >
         <img src="/images/trus1.png" alt="right Side" /></motion.section>
        </div>
      </div>

    </section>


    <section className="i ji ii">
       {/* Bg Shapes */}
      <span className="rc h s r vd fd/5 fh rm"></span>
      <img src="/images/shape-08.svg" alt="Shape Bg" className="h q r" />

      {/* Section Title */}
      <div className="animate_top bb ze rj ki xn vq">
          <motion.section
                       initial={{ opacity: 0, y: 100 }}
                       whileInView={{ opacity: 1, y: 0 }}
                       viewport={{ once: false, amount: 0.3 }} // 👈 play every time visible
                       transition={{
                         duration: 1.8,
                         ease: "easeOut",
                         type: "spring",
                         stiffness: 40,
                         damping: 20,
                       }}
                     ><h2 className="fk vj pr kk wm on/5 gq/2 bb _b">
        Data Enrichment 
        </h2></motion.section>
        
      </div>
      <br/>
      <div className="container">
        <div className="left">
             <motion.section
                       initial={{ opacity: 0, y: 100 }}
                       whileInView={{ opacity: 1, y: 0 }}
                       viewport={{ once: false, amount: 0.3 }} // 👈 play every time visible
                       transition={{
                         duration: 1.8,
                         ease: "easeOut",
                         type: "spring",
                         stiffness: 40,
                         damping: 20,
                       }}
                     >
                <img src="/images/dataenrichment.png" alt="right Side" /></motion.section>
        </div>
        <div className="right">
            <motion.section
                       initial={{ opacity: 0, y: 100 }}
                       whileInView={{ opacity: 1, y: 0 }}
                       viewport={{ once: false, amount: 0.3 }} // 👈 play every time visible
                       transition={{
                         duration: 1.8,
                         ease: "easeOut",
                         type: "spring",
                         stiffness: 40,
                         damping: 20,
                       }}
                     >
          <h3 className="fk tj kk wm bb _b mk">Precision-Driven, Intelligent Data</h3>
            <p className="uo">
                Our B2B data cleansing and audience profiling solutions ensure you engage with the right audience using accurate, up-to-date information. We source data from both internal and external channels, while also enhancing and refining your existing contact lists. Our expertise lies in identifying and correcting incomplete or inaccurate prospect data, as well as eliminating duplicates. The result is a clean, reliable database that offers deeper insights into buyer behavior—ultimately driving higher sales conversions.
         </p>
           <div className="tc tf yo zf mb">
               
          </div>
         </motion.section>
      
        </div>
      </div>

    </section>


    
    <section className="i pg qh rm ji hp relative bgblue">
         
              <motion.section
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.2 }}
            transition={{ duration: 0.8 }}
          >
         <div className="bb ze i va ki xn">
          <div className="tc uf sn tn xf un gg">
            <h3 className="fk vj wm bb _b">Target Smarter, Convert Faster with Intent-Driven ABM</h3>
          </div>
        <center>
           <button
  type="button"
   className="centbtn ek jk lk gh gi hi rg ml il vc _d _l"
  onClick={() => {
    setFormType("Intent Data Services Page");
    openModal(true); // or scroll to form if no modal
  }}
>
     Let's connect
</button></center>
        </div>
          </motion.section>
        </section>
        
{/*        
         <section className="i pg">
           
             <div className="bb ze i va ki xn jb jo">
                  <motion.section
               initial={{ opacity: 0, y: 50 }}
               whileInView={{ opacity: 1, y: 0 }}
               viewport={{ once: true, amount: 0.2 }}
               transition={{ duration: 0.8 }}
             >
               <div className="wc qf pn gg cp">
            
                 <div className="animate_top rj divserv">
                   
                   <h4 className="ek yj mk2 gb">Capture Early Signals Across the Web</h4>
                   <p className="hdse">Your buyers are out there researching right now—reading articles, comparing solutions, and searching for answers. Our platform aggregates third-party intent data across thousands of digital touchpoints and surfaces the companies showing real interest in your solutions, weeks before they ever land on your site.</p>
                <ul>
                  <li>•	Detect surging interest by topic or keyword</li>
                  <li>•	See which accounts are actively researching your competitors</li>
                  <li>•	Prioritize based on intent intensity, not just firmographics</li>
                </ul>
                 </div>
       
                 <div className="animate_top rj divserv">
                   
                   <h4 className="ek yj mk2 gb">Smarter, Data-Driven Outreach</h4>
                   <p className="hdse">Once you know who’s in-market, the next step is reaching out with relevance. Our intent data integrates directly into your CRM and marketing automation platforms, giving your teams real-time insights to personalize outreach at scale.</p>
                <ul>
                  <li>•	Align messaging to what the buyer cares about—right now</li>
                  <li>•	Send fewer, higher-converting emails</li>
                  <li>•	Arm SDRs with context for better first calls</li>
                </ul>
                 <p className="hdse">The result? Your outbound no longer feels cold—it feels timely and tailored.</p>
                 </div>
       
                 <div className="animate_top rj divserv">
                   
                   <h4 className="ek yj mk2 gb">Build a Bigger, Healthier Pipeline</h4>
                   <p className="hdse">Intent data doesn’t just help you find more leads—it helps you focus on the right ones. By prioritizing accounts with high intent, you increase conversion rates, shorten sales cycles, and boost pipeline velocity.</p>
                <ul>
                  <li>•	Accelerate lead qualification with buyer intent scoring</li>
                  <li>•	Fill pipeline gaps with accounts showing active demand</li>
                  <li>•	Drive better ROI from ABM and paid media campaigns</li>
                </ul>
                 </div>
          <div className="animate_top rj divserv">
                   
                   <h4 className="ek yj mk2 gb">Fuel Every Stage of the Buyer’s Journey</h4>
                   <p className="hdse">Whether your buyers are just starting to research or ready to talk to sales, our intent data gives you the visibility to meet them where they are—with the message they need to hear.
                    <br/>
                    From awareness to decision, you’ll never miss a moment to influence the journey.
                   </p>
              
                 </div>
               </div>  
               </motion.section>
                <br/>
             </div>
           </section> */}
   <br/>
    </main>
      <Footer />
    </div>
  );
}

export default Tofuinent;
